module.exports = vendor_bd8c6649f0b1d6e6ce04;


//////////////////
// WEBPACK FOOTER
// external "vendor_bd8c6649f0b1d6e6ce04"
// module id = 1
// module chunks = 1 2